import { render, staticRenderFns } from "./Variables.vue?vue&type=template&id=4676e1c9&scoped=true&"
import script from "./Variables.vue?vue&type=script&lang=js&"
export * from "./Variables.vue?vue&type=script&lang=js&"
import style0 from "./Variables.vue?vue&type=style&index=0&id=4676e1c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676e1c9",
  null
  
)

export default component.exports